import { render, staticRenderFns } from "./DatePickerForm.vue?vue&type=template&id=0507d611&scoped=true&"
import script from "./DatePickerForm.vue?vue&type=script&lang=js&"
export * from "./DatePickerForm.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerForm.vue?vue&type=style&index=0&id=0507d611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507d611",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VIcon,VMenu,VTextField})
